export enum Tables {
    Logging = 'logging',
  }